import { c as _c } from "react/compiler-runtime";
// `<StatBlock>` — label + value pair for OG cards. Used in market /
// portfolio / proposal layouts to surface a single KPI.

import type { ReactNode } from 'react';
import { OG_TOKENS } from '../tokens';
export interface StatBlockProps {
  label: string;
  value: ReactNode;
  /** Optional change indicator below the value (e.g. `+12.4%`). */
  delta?: ReactNode;
  /** Color for the delta text (typically success/danger token). */
  deltaColor?: string;
  /** Stack alignment. `'start'` aligns left (most uses); `'center'` for
   *  hero stats. */
  align?: 'start' | 'center';
}
export function StatBlock(props) {
  const $ = _c(16);
  const align = props.align ?? "start";
  const t0 = align === "center" ? "center" : "flex-start";
  let t1;
  if ($[0] !== t0) {
    t1 = {
      display: "flex",
      flexDirection: "column",
      alignItems: t0,
      gap: 4
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      fontSize: 18,
      color: OG_TOKENS.gray400,
      fontWeight: 500
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props.label) {
    t3 = <span style={t2}>{props.label}</span>;
    $[3] = props.label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      display: "flex",
      fontSize: 44,
      fontWeight: 700,
      color: OG_TOKENS.gray50
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== props.value) {
    t5 = <span style={t4}>{props.value}</span>;
    $[6] = props.value;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== props.delta || $[9] !== props.deltaColor) {
    t6 = props.delta !== undefined && <span style={{
      display: "flex",
      fontSize: 22,
      fontWeight: 500,
      color: props.deltaColor ?? OG_TOKENS.gray300
    }}>{props.delta}</span>;
    $[8] = props.delta;
    $[9] = props.deltaColor;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t1 || $[12] !== t3 || $[13] !== t5 || $[14] !== t6) {
    t7 = <div style={t1}>{t3}{t5}{t6}</div>;
    $[11] = t1;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}